import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";
import { GlobalWorkerOptions } from "pdfjs-dist";
import "pdfjs-dist/web/pdf_viewer.css";
import React, { useEffect, useRef } from "react";


// ✅ Worker từ thư mục public
GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.js`;

interface PDFViewerProps {
  url: string;
}

const PDFViewer: React.FC<PDFViewerProps> = ({ url }) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const renderPDF = async () => {
      if (!containerRef.current) return;
      containerRef.current.innerHTML = "";

      try {
        const loadingTask = (pdfjsLib as any).getDocument(url);
        const pdf = await loadingTask.promise;

        for (let i = 1; i <= pdf.numPages; i++) {
          const page = await pdf.getPage(i);
          const viewport = page.getViewport({ scale: 1.2 });
          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d")!;
          canvas.width = viewport.width;
          canvas.height = viewport.height;
          await page.render({ canvasContext: context, viewport }).promise;
          containerRef.current.appendChild(canvas);
        }
      } catch (err) {
        console.error("❌ Lỗi render PDF:", err);
        containerRef.current.innerHTML = `<p style="color:red">Không thể hiển thị PDF này.</p>`;
      }
    };

    renderPDF();
  }, [url]);

  return (
    <div
      ref={containerRef}
      className="pdf-viewer space-y-4 overflow-auto border rounded-md p-4 bg-white shadow max-h-[800px]"
    />
  );
};

export default PDFViewer;
